import {
  PayeeRequirement,
  RequirementStatus
} from "@wingspanhq/wingspan-api-sdk";

/**
 * v1 gated this on the definition-level `reviewStrategy` plus the
 * `PendingReview` status. v3's `PENDING_PAYER_REVIEW` status value already
 * implies the requirement is on an approval flow and awaiting review, so the
 * status check alone is sufficient — the policy itself is on
 * `PayeeRequirement.reviewPolicy` when the flow, rather than this instance's
 * point in it, is the question (see `selectorIsRequirementWithApprovalFlow`).
 */
export const selectorIsRequirementPendingApproval = (
  requirement: PayeeRequirement
) => {
  return requirement.status === RequirementStatus.PENDING_PAYER_REVIEW;
};
